import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const editSaveVarientSlice = createApi(`EditSaveVarientSlice`,"PUT");

const EditSaveVarientSlice = createSlice({
  name: 'EditSaveVarientSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(editSaveVarientSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editSaveVarientSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(editSaveVarientSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default EditSaveVarientSlice.reducer;